import { BlockDataForm } from '@plone/volto/components';
import { useIntl } from 'react-intl';

import { ChatbotHomeSchema } from './schema';

export const Data = (props) => {
  const { block, data, onChangeBlock, schemaEnhancer } = props;
  const intl = useIntl();
  const schema = schemaEnhancer ? schemaEnhancer(ChatbotHomeSchema({ ...props, intl }), props) : ChatbotHomeSchema({ ...props, intl });

  return (
    <BlockDataForm
      schema={schema}
      title={schema.title}
      onChangeField={(id, value) => {
        onChangeBlock(block, {
          ...data,
          [id]: value,
        });
      }}
      formData={data}
      block={block}
    />
  );
};

export default Data;
